import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Table } from 'reactstrap';
import Skeleton from 'react-loading-skeleton';
import Actions from '../../../Actions';
import Paginate from '../Layout/Paginate';
import UserRow from './UserRow';
import UserAdd from './Add';
import Edit from './Edit';
import Tile from '../Layout/Tile';
import Filter from '../Layout/Filter';


class UserList extends Component {
    componentDidMount = () => {
        const { auth, getUsers } = this.props;
        getUsers(auth.token, {page: 1, order: "asc", sort: "name" }, false);
    }

    edit = (id) => {
        const { users, toggleModal, setModalData } = this.props;
        if(users.hasOwnProperty(id)){
            setModalData("users","edit",users[id]);
            toggleModal("users","edit");
        }
    }

    usersLoading = () => {
        const data = [];
        for(let i=0;i<10;i++){
            data.push(
                <Tile key={i+"-loading"} xs="12" style={{padding: "1vh 1vw"}} className="mx-auto">
                    <Skeleton count={4}/>
                </Tile>
            );
        }

        return data;
    }

    users = () => {
        const { users, usersMeta } = this.props;
        const rows = [];
        const { data = [] } = usersMeta;
        data.map((id) => {
            rows.push(
                <UserRow key={id} edit={this.edit} user={users[id]}/>
            );
        });
        return rows;
    }

    render(){
        const { getUsers, usersLoading, usersMeta, query } = this.props;
        return (
            <div style={{ padding: "3px"}}>        
               {usersLoading ? this.usersLoading():
                    <div>
                        <Table responsive className="text-left">
                            <thead>
                                <tr>
                                    <th className="text-nowrap">
                                        <Filter query={query} id="name" title="Name" field="name" filter={getUsers} />
                                    </th>
                                    <th className="text-nowrap">
                                        <Filter query={query} id="email" title="Email" field="email" filter={getUsers} />
                                    </th>
                                    <th className="text-nowrap">
                                        <Filter query={query} id="role" title="Role" field="role" filter={getUsers} />
                                    </th>
                                    <th className="text-nowrap">
                                        Mail Subscription
                                    </th>
                                    <th>
                                        Send Details
                                    </th>
                                    <th>
                                        Delete
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.users()}
                            </tbody>
                        </Table>
                        <Paginate fetch={getUsers} meta={usersMeta}  />
                        <UserAdd />
                        <Edit />
                    </div>
               }
            </div>
        );
    }
}


const mapStateToProps = (state) => ({
    auth: state.auth,
    users: state.userStore.users,
    usersMeta: state.userStore.usersMeta,
    query: state.userStore.query,
    modalStore: state.modalStore.users,
    usersLoading: state.userStore.usersLoading,
});

const { users, modals } = Actions;

export default connect(mapStateToProps,{ ...users, ...modals })(UserList);


// WEBPACK FOOTER //
// ./src/Components/App/Users/UserList.js